import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import "react-loading-skeleton/dist/skeleton.css";
import Header from "../components/header/boardHeader";

import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Button from "../components/button/button";

// Import supabase configuration
import supabase from "../config/supabase";
import { useCSVReader } from 'react-papaparse';

function CSVCircularProgress(props) {
  return (
    <Box sx={{ position: 'relative' }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: "#c2d7ff"
        }}
        size={80}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: (theme) => (theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8'),
          animationDuration: '1050ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        }}
        size={80}
        thickness={4}
        {...props}
      />
    </Box>
  );
}
  
function CsvUpload() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { CSVReader } = useCSVReader();

    const [data, setData] = useState([]);
    const [dataUploaded, setDataUploaded] = useState(1);
    const [uploadSuccessfull, setUploadSuccessfull] = useState(false);

    useEffect(() => {
    
    }, []);

    const handleCSVData = async(d) => {
        setDataUploaded(2); // data is uploading
        let columnNames = d[0];
        let data = [];
    
        for(let i=1; i < d.length; i++){
          let row = {};
          for(let j = 0; j< columnNames.length ; j++){
            row[columnNames[j]] = d[i][j]
          }
          data.push(row);
        }
    
        // var res = await supabase
        // .from('upload_testing')
        // .insert(data)
        setData(data);

        if(data.length > 0){
          setUploadSuccessfull(true);
        }

        setTimeout(() => {
          setDataUploaded(3); // data is uploaded

        }, 1200);
         
        console.log(data)
      }

    const next = () => {
      var candidates = JSON.parse(localStorage.getItem("candidates")) || [];
      candidates = [...candidates, ...data];
      const uniqueCandidatesArray = removeDuplicates(candidates);
      localStorage.setItem("candidates", JSON.stringify(uniqueCandidatesArray));
      localStorage.setItem('showDraft', true);
      navigate('/candidates');
    }

    // this function will remove duplicates from an array of objects
    const removeDuplicates = (data) => {
      var result = data.reduce((unique, o) => {
          if(!unique.some(obj => obj['Gaper Id'] === o['Gaper Id'])) {
            unique.push(o);
          }
          return unique;
      },[]);
      return result;
    }

    return (
        <div className="w-full min-h-screen bg-blue-7">
            <div className="sticky top-0 z-50">
              <Header current="home" />
            </div>       

            <div className="flex justify-center ">
                
                <div className="w-[370px] md:w-[720px] bg-white-1 my-10 rounded-lg mx-1">

                    <div className="px-5 md:pl-24 md:pr-20 py-14">

                        <div className="">
                          {
                            // Loading
                            dataUploaded == 2 ? <div className="grid grid-cols-12 gap-3 py-4">

                              {/* Add text */}
                              <div className="text-[24px] md:text-[24px] mt-5 font-bold col-span-12 md:text-center">We are trying to fetch your data.</div>

                              <div className="text-[18px] md:text-[18px] col-span-12 md:text-center md:-mt-2 mt-8">Kindly wait while your file is being loaded.</div>

                              {/* Loader */}
                              <div className="col-span-12 flex justify-center md:mt-12 mt-24 mb-24">
                                <div>
                                    <CSVCircularProgress />

                                    <div className="mt-2">Loading...</div>
                                </div>
                              </div>

                              {/* Add text */}
                              <div className="text-[18px] md:text-[18px] col-span-12 text-center mt-14 font-bold mb-4">Importing from CSV file</div>
                            </div> :
                              // Import is successfull
                            (dataUploaded == 3 && uploadSuccessfull == true) ? <div className="grid grid-cols-12 gap-3 -mt-1">
                              {/* Add avatar */}
                              <div className="mt-5 font-bold col-span-12 "> <img src="successemoji.svg"/> </div>

                              {/* Add text */}
                              <div className="text-[24px] md:text-[24px] mt-5 font-bold col-span-12 ">Import was successful!</div>

                              <div className="text-[18px] md:text-[17px] md:col-span-12 col-span-10 leading-8 mt-6 md:-mt-2">Your prospects have been imported.</div>

                              <div className="text-[18px] md:text-[17px] md:col-span-12 col-span-10 md:mt-5 mt-6">Add skills and upload the resumes to complete the candidates profiles.</div>

                              {/* Add button */}
                              <div className="col-span-9 md:mt-7 mt-16  mb-6">
                                <Button buttonType="next" value="Next" className="md:w-[105px]" onClick={() => next()}/>
                              </div>
                            </div> : 

                            // Import is un-successfull
                            (dataUploaded == 3 && uploadSuccessfull == false) ? <div className="grid grid-cols-12 gap-3 -mt-1">
                              {/* Add avatar */}
                              <div className="mt-5 font-bold col-span-12 "> <img src="unsuccessfullemoji.svg"/> </div>

                              {/* Add text */}
                              <div className="text-[24px] md:text-[24px] mt-5 font-bold col-span-12 ">Import was unsuccessful!</div>

                              <div className="text-[18px] md:text-[17px] col-span-10 md:-mt-2 mt-8">We are sorry for the inconvinience.</div>

                              <div className="text-[18px] md:text-[17px] col-span-10 md:mt-5 mt-8">The file you uploaded might be corrupted, missing information or the format isn&#39;t supported. Try again with another file</div>

                              {/* Add button */}
                              <div className="col-span-9 mt-7">
                                <Button buttonType="next" value="Try Again" className="md:w-[150px] mt-8"  onClick={() => {setDataUploaded(1); setUploadSuccessfull(false)}}/>
                              </div>
                            </div> :
                            
                            // Upload csv
                            <div className="grid grid-cols-12 gap-3 py-4">

                              {/* Add text */}
                              <div className="text-[24px] md:text-[24px] mt-5 font-semibold md:text-center col-span-12">Add a CSV file to bulk import candidates</div>

                              <CSVReader
                              onUploadAccepted={(results) => {
                                  handleCSVData(results.data);
                              }}
                              config={{
                                skipEmptyLines: true
                              }}
                              >
                              {({
                                  getRootProps,
                                  acceptedFile,
                                  ProgressBar,
                              }) => (<div className="mt-12 col-span-12 border border-dashed border-black-4 py-4">
                                  <div className="mt-7 flex justify-center " {...getRootProps()}>
                                      {/* Image */}
                                      <img src="download.svg" className="cursor-pointer"/>
                                  </div>

                                  {/* Add text */}
                                  <div className="mt-6 text-[14px] md:text-[18px] mb-10" {...getRootProps()}>
                                      <div  className="text-center cursor-pointer" {...getRootProps()}>Select a file from your computer</div>
                                      <div className="mt-2 text-center">OR</div>
                                      <div className="mt-2 text-center cursor-pointer">Drag and drop it here</div>
                                  </div>
                                  
                              </div>
                              )}
                              </CSVReader>

                              {/* Add link */}
                              <div className="text-[16px] md:text-[18px] md:mt-2 mt-20 col-span-12 text-center">Download template <span className="text-blue-1 cursor-pointer border-b-[0.5px] border-blue-1 leading-3" onClick={() =>  window.open("/sample.csv", "_blank")}>here.</span></div>

                              </div>
                          }
                           </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default CsvUpload;
